// extracted by mini-css-extract-plugin
module.exports = {"ad-banner":"styles_ad-banner__QQ3vc","ad-banner__inner":"styles_ad-banner__inner__zOm4o","ad-banner__close":"styles_ad-banner__close__2potB"};